import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

const Splash = () => <h1> The splash </h1>;
const Flow = () => <h1> The flow </h1>;
const Success = () => <h1> The success </h1>;
export default function App() {
  const { pathname: url } = useLocation();

  return (
    <Routes>
      <Route data-feature="investing_five_two_nine" index={true} element={<Navigate to={`${url}/splash`} />} />
      <Route data-feature="investing_five_two_nine" path="/splash" element={<Splash />} />
      <Route data-feature="investing_five_two_nine" path="/flow" element={<Flow />} />
      <Route data-feature="investing_five_two_nine" path="/success" element={<Success />} />
    </Routes>
  );
}
